import { type WithChildren, DOMProps } from '@dynatrace/strato-components/core';
import { Paragraph, Text } from '@dynatrace/strato-components/typography';

import { useInformationOverlayContext } from './hooks/useInformationOverlayContext.js';

//#region Typings
/**
 * @public
 */
export interface InformationContentProps extends DOMProps, WithChildren {}
//#endregion Typings

/**
 * The content of the InformationOverlay.
 * @public
 */
export const Content = ({ children, id: propId }: InformationContentProps) => {
  const { id } = useInformationOverlayContext();

  if (typeof children === 'string') {
    return <Paragraph id={propId ?? id}>{children}</Paragraph>;
  }
  return (
    <Text as="div" textStyle="base" id={propId ?? id}>
      {children}
    </Text>
  );
};

Content['displayName'] = 'InformationOverlay.Content';
